import { Flex, Spacing } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { LocalStorageKeys } from '../../../../enums/localStorageKeys'
import { SalesReportExportLimitBanner } from '../../elements/SalesReportExportLimitBanner'
import { SalesReportStatistics } from '../../elements/SalesReportStatistics'
import { useSalesByCustomerReport } from '../../hooks/salesByCustomerReport/useSalesByCustomerReport'
import { SalesByCustomerReportTable } from './elements/SalesByCustomerReportTable'

export const SalesByCustomerReport = () => {
  const { t } = useTranslation()
  const { isLoading, salesByCustomerReport } = useSalesByCustomerReport()

  return (
    <Flex flexDirection="column" gap={Spacing.S8} width="100%">
      <SalesReportExportLimitBanner
        bannerMessage={t('sales_report.export_limit_banner.text.customers')}
        localStorageKey={LocalStorageKeys.HideSalesReportCustomersExportLimitBanner}
        salesReportCount={salesByCustomerReport.length}
      />
      <SalesReportStatistics salesReport={salesByCustomerReport} variant="by-customer" isLoading={isLoading} />
      <SalesByCustomerReportTable />
    </Flex>
  )
}
